import { faPencilAlt, faTag, faToggleOff, faToggleOn } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React, { useCallback, useMemo } from "react";
import { Badge, Button, ButtonGroup, ButtonToolbar } from "react-bootstrap";
import { useIntl } from "react-intl";
import { USER_EDITOR } from "../../../common/constant";
import Visibility from "../../../component/common/VisibleContainer";
import {
    ACTIVE,
    CHANGE_USER_STATUS_DIALOG,
    EDIT_USER_DIALOG,
    FIRSTNAME,
    LASTNAME,
    USERNAME
} from "../../../ducks/userManagement";
import SurveyUtils from "../../../utils/SurveyUtils";
import { resolveRoleDisplayName } from "../roleManagement/RoleNameResolver";

const UserManagementTableRow = ({
  sortUserTableBy,
  user,
  userParticipations,
  prepareUserDataForEditing,
  propertyChange,
  locale
}) => {
  const intl = useIntl();

  const renderRoles = useCallback(
    (role) => (
      <Badge pill variant="light">
        <FontAwesomeIcon icon={faTag} className="me-1" />
        {resolveRoleDisplayName(role, locale, intl)}
      </Badge>
    ),
    [locale, intl]
  );

  const openCorrespondingUserDialog = useCallback(
    (user, correspondingDialog) => {
      prepareUserDataForEditing(user);
      propertyChange(correspondingDialog, true);
    },
    [prepareUserDataForEditing, propertyChange]
  );

  return useMemo(
    () => (
      <tr>
        <td className={SurveyUtils.addClassForTableColumns(USERNAME, sortUserTableBy)}>{user.username}</td>
        <td className={SurveyUtils.addClassForTableColumns(FIRSTNAME, sortUserTableBy)}>{user.firstname}</td>
        <td className={SurveyUtils.addClassForTableColumns(LASTNAME, sortUserTableBy)}>{user.lastname}</td>
        <td>
          {user.roles.map((r, i) => (
            <React.Fragment key={i}>{renderRoles(r)} </React.Fragment>
          ))}
        </td>
        <td>
          {userParticipations && (
            <ul className="pl-3 m-0">
              {userParticipations.map((p, i) => (
                <li key={i}>{p.unit ? p.unit.name !== p.unit.foreignId ? `${p.unit.name} (${p.unit.foreignId})` : p.unit.name : "Missing Unit: " + user.username}</li>
              ))}
            </ul>
          )}
        </td>
        <td className={SurveyUtils.addClassForTableColumns(ACTIVE + "_", sortUserTableBy)}>
          {intl.formatMessage({ id: user.active ? "app.common.Yes" : "app.common.No" })}
        </td>
        <Visibility roles={[USER_EDITOR]} as="td" className="actions">
          <ButtonToolbar>
            <ButtonGroup>
              <Button
                variant="link"
                title={intl.formatMessage({ id: "templateList.tooltip.edit" })}
                onClick={() => openCorrespondingUserDialog(user, EDIT_USER_DIALOG)}
              >
                <FontAwesomeIcon icon={faPencilAlt} />
              </Button>
              <Button
                variant="link"
                title={intl.formatMessage({ id: `user.management.action.${user.active ? "de" : ""}activate` })}
                onClick={() => openCorrespondingUserDialog(user, CHANGE_USER_STATUS_DIALOG)}
              >
                <FontAwesomeIcon icon={user.active ? faToggleOff : faToggleOn} />
              </Button>
              {/*

                             !user.createAccountNotificationSent  &&
                             <a>
                             <i className="fa fa-envelope-o" aria-hidden="true"
                             title={intl.formatMessage({"id": "user.management.edit.send.user.account.notification"})}
                             onClick={() => sendUserAccountNotification(user)}
                             />
                             </a>
                             */}
            </ButtonGroup>
          </ButtonToolbar>
        </Visibility>
      </tr>
    ),
    [user, sortUserTableBy, openCorrespondingUserDialog, intl, userParticipations, renderRoles]
  );
};

UserManagementTableRow.propTypes = {
  user: PropTypes.object,
  userParticipations: PropTypes.array,
  sortUserTableBy: PropTypes.string,
  loadUsers: PropTypes.func,
  propertyChange: PropTypes.func,
  prepareUserDataForEditing: PropTypes.func,
  sendUserAccountNotification: PropTypes.func.isRequired
};

export default UserManagementTableRow;
